import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useBackend } from '../../../Hooks/UseBackend';
import { usePumpGateway } from '../../../Hooks/usePumpGateway';
import { CommonUseBubblesProps, useBubbles } from './useBubbles';
import { FeedBubble } from '../types';

export function usePumpFunBubbles(props: CommonUseBubblesProps) {
    const { getPumpFunBubbles } = useBackend();

    const { pumpGatewayClient } = usePumpGateway();

    return useBubbles<Api.Pump.DTO.PumpFunBubble, Api.Pump.DTO.PumpFunBubbleUpdate, FeedBubble<Api.Pump.DTO.PumpFunToken>>({
        ...props,
        getBubbles: getPumpFunBubbles,
        client: pumpGatewayClient,
        updateEventName: Api.Pump.Gateway.Event.BubbleUpdate,
        transform: ({ pumpFunTokens, ...bubble }) => ({
            ...bubble,
            tokens: pumpFunTokens,
        }),
    });
}
